import styled from 'styled-components';

import colors from 'theme/colors';

export const DogParkLayoutStyled = styled.section`
  .ant-table-thead > tr > th {
    background: ${colors.darkestGray};
    font-weight: bold;
  }
`;
